import { InputType } from "../Models/InputType";
import { ValidityState } from "../Models/ValidityState";
const availableControlCharacters = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E",
    "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
const companyCodeValidationArray = [7, 9, 10, 5, 8, 4, 2];

const undefinedInputMaskArray = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
const ssnMaskArray = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[-+Aa]/, /\d/, /\d/, /\d/,
    /[0-9]|[A-Fa-f]|[Hh]|[J-Nj-n]|[Pp]|[R-Yr-y]/];
const companyIdMaskArray = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/];

const companyIdRegEx = /^[\d]{7}-[\d]{0,1}$/;
const ssnRegEx = /^\d{6}[-+A-YXWVUBCDEF]\d{3}([0-9A-FHJK-NPR-Y])$/;

export default class SsnCompanyIdValidationService {
    public getInputMask(rawValue: string, currentInputType: InputType) {
        const inputValue = rawValue.replace(/[_]+/, "");
        let maskArray: Array<string | RegExp>;
        if (inputValue.length > 6) {
            if (rawValue.match(/[\d]{7}-/) || !isNaN(Number(inputValue[6]))) {
                maskArray = companyIdMaskArray;
            } else if (currentInputType !== InputType.Undefined && rawValue.match(/[\d]{6}-\_/)) {
                maskArray = undefinedInputMaskArray;
            } else if (inputValue[6].match(/[-+Aa]/)) {
                maskArray = ssnMaskArray;
            } else {
                maskArray = undefinedInputMaskArray;
            }
        } else {
            maskArray = undefinedInputMaskArray;
        }
        return maskArray;
    }

    public getInputType(inputValue: string) {
        let inputType = InputType.Undefined;
        if (inputValue.length > 6) {
            if (inputValue.match(companyIdRegEx)) {
                inputType = InputType.CompanyId;
            } else if (inputValue.match(ssnRegEx)) {
                inputType = InputType.SSN;
            } else {
                inputType = InputType.Undefined;
            }
        }
        return inputType;
    }

    public getValidityState(inputValue: string, inputType: InputType) {
        let validityState = ValidityState.Valid;
        const controlCharacter = inputValue.slice(-1)[0].toUpperCase();
        switch (inputType) {
            case (InputType.SSN):
                if (!inputValue.slice(0, 6).match(/^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{2}$/)) {
                    validityState = ValidityState.InvalidDate;
                } else if (!inputValue.slice(7, 10).match(/^(00[2-9]|0[1-9][0-9]|[1-8][0-9][0-9])$/)) {
                    validityState = ValidityState.InvalidPersonalNumber;
                } else if (controlCharacter !== this.calculateSsnControlCharacter(inputValue)) {
                    validityState = ValidityState.InvalidSsnControlCharacter;
                }
                break;
            case (InputType.CompanyId):
                const validControlCharacter = this.calculateCompanyIdControlMark(inputValue);
                if (validControlCharacter === null) {
                    validityState = ValidityState.InvalidCompanyIdBody;
                } else if (controlCharacter !== validControlCharacter) {
                    validityState = ValidityState.InvalidCompanyIdControlCharacter;
                }
                break;
            default:
                validityState = ValidityState.InvalidDataFormat;
                break;
        }
        return validityState;
    }

    public calculateCompanyIdControlMark(inputValue: string): string {
        const charrArr = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < inputValue.length; i++) {
            charrArr.push(inputValue[i]);
        }
        const inputAsNumberArray = charrArr
            .filter((x) => x >= "0" && x <= "9")
            .map((x) => Number(x));

        if (inputAsNumberArray.length < 6) {
            return null;
        }

        let sum = 0;
        for (let i = 0; i < 7; i++) {
            sum += inputAsNumberArray[i] * companyCodeValidationArray[i];
        }

        const remainder = sum % 11;
        if (remainder === 0) {
            return "0";
        } else if (remainder === 1) {
            return null;
        }
        return (11 - remainder).toString();
    }

    public calculateSsnControlCharacter(inputValue: string): string {
        const initialNumber = Number(inputValue.slice(0, 6) + inputValue.slice(7, 10));
        if (!isNaN(initialNumber)) {
            const remainder = initialNumber % 31;
            if (remainder < 10) {
                return remainder.toString();
            } else if (remainder <= 30) {
                return availableControlCharacters[remainder].toString();
            }
            return null;
        }
        return null;
    }
}
